import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CloseButtonModule } from '../../_shared/components/close-button/close-button.module';

import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TeamSelectorComponent } from './team-selector.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        CloseButtonModule
    ],
    exports: [
        TeamSelectorComponent
    ],
    declarations: [
        TeamSelectorComponent
    ]
})
export class TeamSelectorModule { }
